import { render, staticRenderFns } from "./srid.vue?vue&type=template&id=59c86e55&scoped=true"
import script from "./srid.vue?vue&type=script&lang=js"
export * from "./srid.vue?vue&type=script&lang=js"
import style0 from "./srid.vue?vue&type=style&index=0&id=59c86e55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c86e55",
  null
  
)

export default component.exports